import { FinalExecutionOutcome } from "@near-js/types";

const TRX_ERROR_LOG = {
  RETURN_NEAR: "Return Near because of:",
};

export const getErrorsFromLogs = (transactions: (FinalExecutionOutcome | void)[]): string[] => {
  const errors: string[] = [];
  try {
    transactions.forEach((transaction) => {
      transaction?.receipts_outcome.forEach((receipt) => {
        receipt.outcome.logs.forEach((log) => {
          if (log.includes(TRX_ERROR_LOG.RETURN_NEAR)) {
            errors.push(log);
          }
        });
      });
    });

    return errors;
  } catch (e) {
    return [];
  }
};
